/**
 * Formata um valor monetário para o padrão Quetzal guatemalteco
 * Formato: Q 1,234.56
 * @param value - String com o valor a ser formatado
 * @returns String formatada com a máscara de Quetzal
 */
export const formatQuetzal = (value: string): string => {
  if (!value) return ''

  // Remove tudo exceto dígitos
  const digits = value.replace(/\D/g, '')
  
  if (!digits) return ''

  // Converte para número considerando os dois últimos dígitos como centavos
  const number = parseInt(digits, 10) / 100

  // Formata com símbolo Q e separadores apropriados
  return new Intl.NumberFormat('es-GT', {
    style: 'currency',
    currency: 'GTQ',
    currencyDisplay: 'symbol',
  }).format(number)
}

/**
 * Remove a formatação e retorna apenas os dígitos
 * @param value - String formatada
 * @returns String com apenas dígitos
 */
export const unformatQuetzal = (value: string): string => {
  return value.replace(/\D/g, '')
}

/**
 * Converte valor formatado para número
 * @param value - String formatada
 * @returns Número decimal
 */
export const quetzalToNumber = (value: string): number => {
  const digits = unformatQuetzal(value)
  return digits ? parseInt(digits, 10) / 100 : 0
}